/**
 * modal container
 * */

import React from 'react';
import { useSelector } from "react-redux";
import { selectIsMainModalOpen, selectIsSubModalOpen } from "../../redux/modal-slice/modalSlice";
import {MainModalPortal, SubModalPortal} from "./utils/ModalPortals";

const ModalIndex = () => {
  const isMainModalOpen = useSelector(selectIsMainModalOpen);
  const isSubModalOpen = useSelector(selectIsSubModalOpen);

  return (
    <>
      <div className={"modal-wrap"} style={{display: isMainModalOpen ? "block" : "none"}}>
        <div className={"modal-container"}>
          <div className={"modal"} id={"ROOT_MODAL"}/>
        </div>
      </div>

      <div className={"sub-modal-wrap"} style={{display: isSubModalOpen ? "block" : "none"}}>
        <div className={"sub-modal-container"}>
          <div className={"sub-modal"} id={"SUB_MODAL"}/>
        </div>
      </div>
      <MainModalPortal/>
      <SubModalPortal/>
    </>
  );
};

export default ModalIndex;
